import { Routes } from '@angular/router';

import { UrlService } from '@core/shared/util';
import { provideCategoriesDataAccess } from '@mp/content-manager/categories/data-access';
import { provideFeedbackDataAccess } from '@mp/shared/helper-links/feedback/data-access';
import { provideHelpCenterDataAccess } from '@mp/shared/helper-links/help-center/data-access';
import {
  provideOrganizationsDataAccess,
  provideRolesDataAccess,
  provideUsersDataAccess,
} from '@mpk/shared/data-access';
import { provideAddressesDataAccess, provideCostCentersDataAccess } from '@mpomd/shared/data-access';

import { AppLayoutComponent } from './app-layout/app-layout.component';

export const routes: Routes = [
  {
    path: 'no-organization',
    loadComponent: () => import('@mpe/shared').then((m) => m.NoOrganisationComponent),
  },
  {
    path: 'active-organization-selection',
    loadChildren: async () => (await import('@mpauth/routes')).ACTIVE_ORGANIZATION_SELECTOR_ROUTES,
  },
  {
    path: '',
    component: AppLayoutComponent,
    providers: [
      provideFeedbackDataAccess(),
      provideHelpCenterDataAccess(),
      provideOrganizationsDataAccess(),
      provideUsersDataAccess(),
      provideRolesDataAccess(),
      provideCategoriesDataAccess(),
      provideCostCentersDataAccess(),
      provideAddressesDataAccess(),
    ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: async () => (await import('./landing-page/landing-page.component')).LandingPageComponent,
        title: 'Startseite',
      },
      {
        path: 'profile',
        loadChildren: async () => (await import('@mpauth/routes')).PROFILE_ROUTES,
      },
      {
        path: 'exports',
        providers: [UrlService],
        loadChildren: async () => (await import('@mpem/routes')).EXPORT_HISTORY_ROUTES,
        title: 'Export Historie',
      },

      /** Other routes are inserted here by route-builder during app init */
    ],
  },
];
